export const SEGMENT_CHART_OPTIONS = {
    chart: { type: 'donut' },
    noData: {
        text: 'No data to display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
            color: '#000000',
            fontSize: '14px'
        }
    },
    stroke: { show: false },
    states: {
        hover: {
            filter: {
                type: 'darken',
                value: 0.50
            }
        }
    },
    colors: ['#F3DBF1', '#E9BEE3', '#DB97D2', '#C76EBA', '#AD509E', '#8C3F7D', '#733567', '#733567'],
    legend: {
        show: false,
        showForSingleSeries: true,
        position: 'bottom',
        horizontalAlign: 'center', 
        verticalAlign: 'middle',
        fontSize: '12px'
    },
    dataLabels: { enabled: false },
    tooltip: {
        fillSeriesColor: false,
        theme: 'dark',
        y: {
            formatter: function (value, {
                series, seriesIndex, dataPointIndex 
            }) {
                return `${value}%`;
            }
        }     
    }
};

export const SEGMENT_CHART_SERIES = [44, 55, 13, 33];

export const CHANNEL_CHART_OPTIONS = {
    chart: { type: 'donut' },
    noData: {
        text: 'No data to display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
            color: '#000000',
            fontSize: '14px'
        }
    },
    stroke: { show: false },
    states: {
        hover: {
            filter: {
                type: 'darken',
                value: 0.50
            }
        }
    },
    colors: ['#E0F2FE', '#36BFFA', '#0BA5EC', '#026AA2'],
    legend: {
        show: false,
        showForSingleSeries: true,
        position: 'bottom',
        horizontalAlign: 'center', 
        verticalAlign: 'middle',
        fontSize: '12px'
    },
    dataLabels: { enabled: false },
    tooltip: {
        fillSeriesColor: false,
        theme: 'dark',
        y: {
            formatter: function (value, {
                series, seriesIndex, dataPointIndex 
            }) {
                return `${value}%`;
            }
        }    
    }
};

export const NPI_SEGMENT_CHART_OPTIONS = {
    chart: { type: 'donut' },
    noData: {
        text: 'No data to display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
            color: '#000000',
            fontSize: '14px'
        }
    },
    stroke: { show: false },
    states: {
        hover: {
            filter: {
                type: 'darken',
                value: 0.50
            }
        }
    },
    colors: ['#F3DBF1', '#E9BEE3', '#DB97D2', '#C76EBA', '#AD509E', '#8C3F7D', '#733567', '#733567'],
    legend: {
        show: false,
        showForSingleSeries: true,
        position: 'bottom',
        horizontalAlign: 'center', 
        verticalAlign: 'middle',
        fontSize: '12px'
    },
    dataLabels: { enabled: false },
    tooltip: {
        fillSeriesColor: false,
        theme: 'dark',
        y: {
            formatter: function (value, {
                series, seriesIndex, dataPointIndex 
            }) {
                return `${value}`;
            }
        }     
    }
};